import { render, staticRenderFns } from "./cams.vue?vue&type=template&id=50441b8e"
import script from "./cams.vue?vue&type=script&lang=js"
export * from "./cams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports